import { z } from 'zod';
import { supportSchema } from './Support';

export const routeDescriptionSchema = z.object({
  meta: z.object({
    key: z.string(),
    name: z.string(),
    desc: z.string(),
    matchable: z.boolean(),
    support: supportSchema,
  }),
  endpoint: z.string(),
});

export type RouteDescription = z.infer<typeof routeDescriptionSchema>;
